module.exports = __webpack_public_path__ + "static/img/none-course.01e2616.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/imgs/none-course.png
// module id = PNr7
// module chunks = 35